import { STATE_ABBR_TO_NAME } from '@/utils/consts/city/city-abbr-to-name.const';
import { City } from '@/types/city.type';
import { removeAccentuation } from '@/utils/formatters/remove-accentuations';

const normalizeCityName = (name: string) =>
  removeAccentuation(name ?? '')
    .toLowerCase()
    .replace(/['’`´]/g, "'");

export async function getCitySlug(city: string, state: string): Promise<City | null> {
  if (!STATE_ABBR_TO_NAME[state]) {
    return null;
  }

  const citiesFromStateModule = await import(`@/utils/consts/city/city-by-state/${state.toLowerCase()}`);

  const cities: City[] = citiesFromStateModule[`ALL_CITIES_${state}`];
  if (!cities) {
    return null;
  }

  const selectedCity = cities.find((value) => {
    return normalizeCityName(value?.city) === normalizeCityName(city);
  });

  return selectedCity ?? null;
}
